<style lang="less" scoped>
@import '@/style/index.less';

.float-view{
  position: fixed;
  z-index: 1000;
  bottom: 64px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  .float-item{
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);
    @border: 1px @MainDangerColor solid;
    padding: 8px 8px;
    margin-right: 8px;
    background-color: @MainDangerColor;
    color: #fff;
    border: @border;
    border-radius: 4px;
    cursor: pointer;
    &:last-child{
      margin-right: 0px;
    }
    &.choice{
      color: @MainDangerColor;
      background-color: #fff;
    }
  }
}

</style>

<template>
  <div class="float-view" :style="{ left: layout.data.extra.width + 16 + 'px' }">
    <FloatItem v-for="(val, key) in floatData.list" :key="val.id" :data="val" :index="key" @remove="onRemove" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import FloatItem from './FloatItem'
import floatData, { FloatValue } from './floatData'
import { reactiveLayout } from '@/plugin'

export default defineComponent({
  name: 'FloatView',
  components: {
    FloatItem
  },
  data() {
    return {
      floatData: floatData,
      layout: reactiveLayout
    }
  },
  methods: {
    onRemove(index: number, data: FloatValue) {
      data.destroy()
      floatData.remove(data)
    }
  }
})
</script>
